/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

//window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import { createApp } from 'vue';

import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import Toast from 'primevue/toast';
import ItemCreate from './components/item/create.vue';
import ItemEdit from './components/item/edit.vue';

import TagCreate from './components/item/tag.vue';

import UserEdit from './components/user/edit.vue';
import ItemLinkEvaluation from './components/item_link/evaluation.vue';
import ItemEvaluation from './components/item/evaluation.vue';

import UserUserItemListForm from './components/user/user_item_list/form.vue';
import MyUserItemListEdit from './components/user/user_item_list/edit.vue';

import ItemUserItemListForm from './components/item/user_item_list/form.vue';

import ContactForm from './components/contact/form.vue';

import itemLinkForm from './components/item/components/itemLinkForm.vue';


import Message from 'primevue/message';
import pButton from "primevue/button";

import "primevue/resources/themes/lara-light-blue/theme.css" // テーマ
import "primevue/resources/primevue.min.css" // ベース
import "primeicons/primeicons.css" // アイコン
import "primeflex/primeflex.css" // primeflex

import { i18nVue } from 'laravel-vue-i18n'

const app = createApp({
    components:{
        //ExampleComponent,
        ItemCreate,
        ItemEdit,
        TagCreate,
        UserEdit,
        ItemLinkEvaluation,
        ItemEvaluation,
        UserUserItemListForm,
        ItemUserItemListForm,
        ContactForm,
        MyUserItemListEdit,
        Toast,
        Message,
        pButton,
        itemLinkForm,
    }
});

app.use(PrimeVue);
app.use(ToastService);
app.use(ConfirmationService);
app.use(i18nVue, {
  resolve: lang => import(`../lang/${lang}.json`),
})


app.mount('#app');


window.copyClipbord = function(obj, copyText) {
    const p = obj.parentElement.querySelector("p")
    p.style.display = "block"
    /* Copy the text inside the text field */
    if(window.navigator.clipboard) {
        window.navigator.clipboard.writeText(copyText);
    }
    setTimeout(function(){
        p.style.display = "none"
    }, 1500)

}
